<template>
  <div class="landing">
    <!-- 顶部导航栏 -->
    <header class="header">
      <div class="header-top">
        <div class="header-container">
          <div class="header-links">
            <a href="javascript:;" class="header-link">关于我们</a>
            <!-- <a href="javascript:;" class="header-link">国际科研夏校研学营地</a> -->
          </div>
          <div class="header-right">
            <div class="lang-switch">
              <span class="lang-active">中文</span>
              <!-- <span class="lang-divider">|</span> -->
              <!-- <span class="lang-item">English</span> -->
            </div>
            <div class="auth-btns">
              <template v-if="!isLoggedIn">
                <el-button type="text" size="small" @click="goLogin">登录</el-button>
                <span class="lang-divider">|</span>
                <el-button type="text" size="small" @click="goRegister">注册</el-button>
              </template>
              <template v-else>
                <el-dropdown trigger="hover" @command="handleUserCommand">
                  <span class="user-info">
                    <i class="el-icon-user-solid"></i>
                    <span class="user-name">{{ userName }}</span>
                    <i class="el-icon-arrow-down"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="dashboard">个人信息</el-dropdown-item>
                    <el-dropdown-item v-if="currentUserInfo && currentUserInfo.roleId === 1" command="selectedCourses">已选课程</el-dropdown-item>
                    <el-dropdown-item command="competitionArchive">竞赛档案</el-dropdown-item>
                    <el-dropdown-item command="subjectSelect">进入平台</el-dropdown-item>
                    <el-dropdown-item command="logout" divided>退出登录</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div class="header-main">
        <div class="header-container">
          <div class="logo-wrap" @click="scrollToTop">
            <img class="logo-img" src="/logo.png" alt="logo" />
            <div class="logo-text">
              <span class="logo-title">国际学术挑战</span>
              <!-- <span class="logo-subtitle">亚洲最大青少年学术挑战平台</span> -->
            </div>
          </div>
          <nav class="main-nav">
            <div class="nav-items">
              <!-- 数学 -->
              <el-popover placement="bottom" trigger="hover" popper-class="nav-dropdown-popper" :open-delay="100">
                <div class="dropdown-content">
                  <div class="dropdown-section">
                    <div class="dropdown-title">AMC 系列</div>
                    <div class="dropdown-items">
                      <a href="javascript:;" class="dropdown-item" @click.prevent="goAmc('amc8')">AMC 8</a>
                      <a href="javascript:;" class="dropdown-item" @click.prevent="goAmc('amc10')">AMC 10</a>
                      <a href="javascript:;" class="dropdown-item" @click.prevent="goAmc('amc12')">AMC 12</a>
                    </div>
                  </div>
                  <div class="dropdown-divider"></div>
                  <div class="dropdown-section">
                    <div class="dropdown-title">袋鼠数学</div>
                    <div class="dropdown-items dropdown-items-grid">
                      <a v-for="lvl in 6" :key="lvl" href="javascript:;" class="dropdown-item" @click.prevent="goKangaroo(lvl)">LEVEL {{ lvl }}</a>
                    </div>
                  </div>
                </div>
                <div slot="reference" class="nav-item">
                  <span>数学</span>
                  <i class="el-icon-arrow-down"></i>
                </div>
              </el-popover>

              <!-- 编程 -->
              <el-popover placement="bottom" trigger="hover" popper-class="nav-dropdown-popper" :open-delay="100">
                <div class="dropdown-content">
                  <div class="dropdown-section">
                    <div class="dropdown-title">GESP 系列</div>
                    <div class="dropdown-items dropdown-items-grid">
                      <a v-for="lvl in 8" :key="lvl" href="javascript:;" class="dropdown-item" @click.prevent="gespComingSoon(lvl)">{{ lvl }} 级</a>
                    </div>
                  </div>
                </div>
                <div slot="reference" class="nav-item">
                  <span>编程</span>
                  <i class="el-icon-arrow-down"></i>
                </div>
              </el-popover>

              <!-- 英语 -->
              <el-popover placement="bottom" trigger="hover" popper-class="nav-dropdown-popper" :open-delay="100">
                <div class="dropdown-content">
                  <div class="dropdown-section">
                    <div class="dropdown-title">英语课程</div>
                    <div class="dropdown-items">
                      <a href="javascript:;" class="dropdown-item" @click.prevent="englishComingSoon">敬请期待</a>
                    </div>
                  </div>
                </div>
                <div slot="reference" class="nav-item">
                  <span>英语</span>
                  <i class="el-icon-arrow-down"></i>
                </div>
              </el-popover>
            </div>
          </nav>
          <div class="header-search">
            <el-input v-model.trim="searchKeyword" placeholder="搜索项目" size="small" class="search-input" @keyup.enter.native="doSearch">
              <i slot="prefix" class="el-icon-search"></i>
            </el-input>
          </div>
        </div>
      </div>
    </header>

    <!-- 轮播图区域 -->
    <section class="hero-section">
      <el-carousel height="500px" :interval="5000" arrow="always" class="hero-carousel">
        <el-carousel-item v-for="(slide, idx) in heroSlides" :key="idx">
          <div class="hero-slide" :style="{ backgroundImage: 'url(' + slide.image + ')' }">
            <div class="hero-overlay"></div>
            <div class="hero-content">
              <h1 class="hero-title">{{ slide.title }}</h1>
              <p class="hero-desc">{{ slide.desc }}</p>
              <el-button type="primary" size="medium" class="hero-btn" @click="onSlideAction(slide)">立即了解</el-button>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </section>

    <section class="recommend-section">
      <div class="section-container">
        <div class="recommend-header">重点推荐</div>
        <div class="recommend-grid">
          <div
            v-for="item in recommendPanels"
            :key="item.key"
            class="recommend-card"
            :style="{ backgroundImage: 'url(' + item.image + ')' }"
            @click="onRecommendPanelClick(item)"
          >
            <div class="recommend-mask"></div>
            <div class="recommend-title">{{ item.title }}</div>
          </div>
        </div>
      </div>
    </section>

    <!-- 悉迹精选（外部广告）
    <section class="featured-section" v-if="externalBanners.length > 0">
      <div class="section-container">
        <div class="section-header">
          <h2 class="section-title">悉迹精选</h2>
          <p class="section-subtitle">为您精选优质学术资讯</p>
        </div>
        <div class="news-feed">
          <div
            v-for="item in externalBanners"
            :key="item.key"
            class="news-item"
            @click="onExternalBannerClick(item)"
          >
            <div class="news-image">
              <img :src="item.image" :alt="item.title" />
            </div>
            <div class="news-info">
              <h3 class="news-title">{{ item.title }}</h3>
              <p class="news-desc" v-if="item.desc">{{ item.desc }}</p>
            </div>
            <div class="news-arrow">
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
        </div>
      </div>
    </section>-->

    <!-- 热门项目（暂时注释） -->
    <!-- <section class="projects-section">
      <div class="section-container">
        <div class="section-header">
          <h2 class="section-title">热门项目</h2>
          <p class="section-subtitle">精选国际顶级学术挑战项目</p>
        </div>
        <div class="projects-grid">
          <div v-for="project in featuredProjects" :key="project.key" class="project-card" @click="handleProjectClick(project)">
            <div class="project-card-image" :style="{ backgroundImage: 'url(' + project.image + ')' }">
              <div class="project-card-badge" v-if="project.badge">{{ project.badge }}</div>
            </div>
            <div class="project-card-body">
              <h3 class="project-card-title">{{ project.title }}</h3>
              <p class="project-card-desc">{{ project.desc }}</p>
              <div class="project-card-footer">
                <span class="project-card-tag">{{ project.category }}</span>
                <span class="project-card-action">立即了解 →</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section> -->

    <!-- 学科分类区域 -->
    <!-- <section class="categories-section">
      <div class="section-container">
        <div class="section-header">
          <h2 class="section-title">按学科浏览</h2>
          <p class="section-subtitle">涵盖数学、物理、化学、生物、信息学等多个学科领域</p>
        </div>
        <div class="category-tabs">
          <div v-for="cat in subjectCategories" :key="cat.key" class="category-tab" :class="{ active: activeCategory === cat.key }" @click="activeCategory = cat.key">
            <i :class="cat.icon"></i>
            <span>{{ cat.title }}</span>
          </div>
        </div>
        <div class="category-content">
          <div class="project-list">
            <div v-for="project in currentCategoryProjects" :key="project.key" class="project-item" @click="handleProjectClick(project)">
              <div class="project-icon" :style="{ backgroundColor: project.color }">
                <i :class="project.icon || 'el-icon-trophy'"></i>
              </div>
              <div class="project-info">
                <h4 class="project-title">{{ project.title }}</h4>
                <p class="project-subtitle">{{ project.subtitle }}</p>
              </div>
              <div class="project-arrow">
                <i class="el-icon-arrow-right"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section> -->

    <!-- 统计数据区域 -->
    <!-- <section class="stats-section">
      <div class="section-container">
        <div class="stats-grid">
           <div class="stat-item"> -->
            <!-- <div class="stat-number">100+</div> -->
            <!-- <div class="stat-label">国际学术项目</div> -->
          <!-- </div> -->
          <!-- <div class="stat-item"> -->
            <!-- <div class="stat-number">50万+</div> -->
            <!-- <div class="stat-label">参与学生</div> -->
          <!-- </div> -->
          <!-- <div class="stat-item"> -->
            <!-- <div class="stat-number">30+</div> -->
            <!-- <div class="stat-label">合作国家</div> -->
          <!-- </div> -->
          <!-- <div class="stat-item"> -->
            <!-- <div class="stat-number">15年+</div> -->
            <!-- <div class="stat-label">专业经验</div> -->
          <!-- </div> -->
        <!-- </div> -->
      <!-- </div> -->
    <!-- </section> -->

    <!-- 页脚 -->
    <el-dialog
      title="已选课程"
      :visible.sync="selectedCoursesVisible"
      width="420px"
      :close-on-click-modal="true"
    >
      <div v-loading="selectedCoursesLoading" class="selected-courses-dialog">
        <div v-if="!selectedCoursesLoading && !selectedCourses.length" class="selected-courses-empty">
          暂无已制定学习计划的课程
        </div>
        <div v-else class="selected-courses-list">
          <div
            v-for="item in selectedCourses"
            :key="item.key"
            class="selected-course-item"
            @click="goToSelectedCourse(item)"
          >
            <div class="selected-course-main">
              <div class="selected-course-title">{{ item.title }}</div>
              <div class="selected-course-subtitle">{{ item.subtitle }}</div>
            </div>
            <i class="el-icon-arrow-right selected-course-arrow"></i>
          </div>
        </div>
      </div>
    </el-dialog>

    <footer class="footer">
      <div class="footer-main">
        <div class="section-container">
          <div class="footer-grid">
            <div class="footer-col">
              <h4 class="footer-title">关于我们</h4>
              <p class="footer-text">致力于为亚洲青少年提供最优质的国际学术挑战平台，助力学生在全球舞台上展现才华。</p>
            </div>
            <!-- <div class="footer-col">
              <h4 class="footer-title">快速链接</h4>
              <div class="footer-links">
                <a href="javascript:;" class="footer-link">高中项目</a>
                <a href="javascript:;" class="footer-link">初中项目</a>
                <a href="javascript:;" class="footer-link">小学项目</a>
                <a href="javascript:;" class="footer-link" @click="goContact">联系我们</a>
              </div>
            </div> -->
            <div class="footer-col">
              <h4 class="footer-title">热门项目</h4>
              <div class="footer-links">
                <a href="javascript:;" class="footer-link" @click="goAmc('amc8')">美国数学测评 AMC 8</a>
                <a href="javascript:;" class="footer-link" @click="goAmc('amc10')">美国数学测评 AMC 10</a>
                <a href="javascript:;" class="footer-link" @click="goAmc('amc12')">美国数学测评 AMC 12</a>
                <a href="javascript:;" class="footer-link" @click="goKangaroo(1)">袋鼠数学思维挑战</a>
                <a href="javascript:;" class="footer-link" @click="goCcfGesp()">CCF-GESP</a>
              </div>
            </div>
            <div class="footer-col">
              <h4 class="footer-title">联系方式</h4>
              <div class="footer-contact">
                <p><i class="el-icon-message"></i> support@smartpany.freeqiye.com</p>
                <p><i class="el-icon-phone"></i>13584060997</p>
              </div>
            </div>
            <div class="footer-col">
              <h4 class="footer-title">下载 APP</h4>
              <div class="footer-links">
                <a href="javascript:;" class="footer-link footer-app-link" @click="openAppDownloadPage">
                  <i class="el-icon-mobile-phone"></i>
                  <span>下载悉迹AI App</span>
                </a>
                <!-- <p class="footer-app-tip">安卓扫码下载，iOS 请前往 App Store 搜索“悉迹AI”</p> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-bottom">
        <div class="section-container">
          <div class="beian-info">
            <p class="copyright">© {{ new Date().getFullYear() }} 南京悉迹智能科技有限公司 版权所有</p>
            <p>
              <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer" class="beian-link">
                苏ICP备2025227646号
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { getToken, removeToken } from '@/utils/auth'
import { getTokenInfo } from '@/utils/jwtUtils'
import { getUserRedirectPath } from '@/utils/userStatus'
import { fetchPaging as fetchRepoList } from '@/api/repo'
import { getPlansByUserId } from '@/api/studyPlan'
import axios from 'axios'

export default {
  name: 'Landing',
  data() {
    return {
      authTick: 0,
      searchKeyword: '',
      activeCategory: 'math',
      selectedCoursesVisible: false,
      selectedCoursesLoading: false,
      selectedCourses: [],
      repoListCache: [],
      heroSlides: [],
      externalBanners: [],
      recommendPanels: [
        {
          key: 'recommend-1',
          title: 'AMC',
          image: 'https://images.unsplash.com/photo-1523240795612-9a054b0db644?auto=format&fit=crop&w=1200&q=80',
          action: { type: 'intro', introType: 'amc8' }
        },
        {
          key: 'recommend-2',
          title: '袋鼠数学',
          image: 'https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=1200&q=80',
          action: { type: 'intro', introType: 'kangaroo' }
        },
        {
          key: 'recommend-3',
          title: 'CCF-GSEP',
          image: 'https://images.unsplash.com/photo-1496307653780-42ee777d4833?auto=format&fit=crop&w=1200&q=80',
          action: { type: 'intro', introType: 'gesp' }
        }
      ],
      featuredProjects: [
        { key: 'amc8', title: '美国数学测评 AMC 8', desc: '适合8年级及以下学生的数学测评', category: '数学', badge: '热门', image: 'https://images.unsplash.com/photo-1596495578065-6e0763fa1178?auto=format&fit=crop&w=800&q=80', action: { type: 'intro', introType: 'amc8' } },
        { key: 'amc10', title: '美国数学测评 AMC 10', desc: '适合10年级及以下学生的数学测评', category: '数学', badge: '推荐', image: 'https://images.unsplash.com/photo-1635070041078-e363dbe005cb?auto=format&fit=crop&w=800&q=80', action: { type: 'intro', introType: 'amc10' } },
        { key: 'kangaroo', title: '袋鼠数学思维挑战', desc: '全球最大规模的青少年数学思维挑战', category: '数学', image: 'https://images.unsplash.com/photo-1509228468518-180dd4864904?auto=format&fit=crop&w=800&q=80', action: { type: 'intro', introType: 'kangaroo' } },
        { key: 'amc12', title: '美国数学测评 AMC 12', desc: '适合12年级及以下学生的数学测评', category: '数学', image: 'https://images.unsplash.com/photo-1636466497217-26a8cbeaf0aa?auto=format&fit=crop&w=800&q=80', action: { type: 'intro', introType: 'amc12' } },
        { key: 'gesp', title: 'CCF-GESP', desc: '中国计算机学会编程能力等级认证', category: '编程', image: 'https://images.unsplash.com/photo-1517694712202-14dd9538aa97?auto=format&fit=crop&w=800&q=80', action: { type: 'intro', introType: 'gesp' } }
      ],
      subjectCategories: [
        { key: 'math', title: '数学', icon: 'el-icon-data-line' },
        { key: 'physics', title: '物理', icon: 'el-icon-cpu' },
        { key: 'chemistry', title: '化学', icon: 'el-icon-magic-stick' },
        { key: 'biology', title: '生物', icon: 'el-icon-cherry' },
        { key: 'cs', title: '信息学', icon: 'el-icon-monitor' },
        { key: 'business', title: '商科', icon: 'el-icon-office-building' }
      ],
      categoryProjects: {
        math: [
          { key: 'amc8', title: '美国数学测评 AMC 8', subtitle: '适合8年级及以下学生', color: '#1890ff', action: { type: 'amc', level: 'amc8' } },
          { key: 'amc10', title: '美国数学测评 AMC 10', subtitle: '适合10年级及以下学生', color: '#1890ff', action: { type: 'amc', level: 'amc10' } },
          { key: 'amc12', title: '美国数学测评 AMC 12', subtitle: '适合12年级及以下学生', color: '#1890ff', action: { type: 'amc', level: 'amc12' } },
          { key: 'kangaroo', title: '袋鼠数学思维挑战', subtitle: '全球最大规模数学思维挑战', color: '#52c41a', action: { type: 'kangaroo', level: 1 } },
          { key: 'smc', title: '英国数学测评 SMC', subtitle: '英国高级数学测评', color: '#722ed1', action: { type: 'coming' } },
          { key: 'seamo', title: '新加坡亚太数学奥林匹克', subtitle: 'SEAMO 系列', color: '#eb2f96', action: { type: 'coming' } }
        ],
        physics: [
          { key: 'bpho', title: '英国物理测评 BPhO', subtitle: '英国最权威物理竞赛', color: '#fa541c', action: { type: 'coming' } },
          { key: 'physicsbowl', title: '物理杯 PhysicsBowl', subtitle: '美国高中物理测评', color: '#fa8c16', action: { type: 'coming' } },
          { key: 'cap', title: '加拿大物理测评 CAP', subtitle: '加拿大物理测评', color: '#faad14', action: { type: 'coming' } }
        ],
        chemistry: [
          { key: 'ukcho', title: '英国化学测评 UKChO', subtitle: '英国化学奥林匹克', color: '#13c2c2', action: { type: 'coming' } },
          { key: 'ccc', title: '加拿大化学测评 CCC', subtitle: '加拿大化学竞赛', color: '#1890ff', action: { type: 'coming' } }
        ],
        biology: [
          { key: 'bbo', title: '英国生物测评 BBO', subtitle: '英国生物奥林匹克', color: '#52c41a', action: { type: 'coming' } },
          { key: 'usabo', title: '美国生物测评', subtitle: 'BIO USACN', color: '#73d13d', action: { type: 'coming' } }
        ],
        cs: [
          { key: 'bebras', title: '海狸国际计算思维挑战', subtitle: '全球最大信息学普及活动', color: '#2f54eb', action: { type: 'gesp' } },
          { key: 'acsl', title: '美国计算机科学思维测评', subtitle: 'ACSL 系列', color: '#722ed1', action: { type: 'coming' } },
          { key: 'gesp', title: 'GESP 编程等级考试', subtitle: '1-8级编程能力认证', color: '#eb2f96', action: { type: 'gesp' } }
        ],
        business: [
          { key: 'abs', title: '阿思丹模拟商业挑战', subtitle: '商业模拟与创业实践', color: '#faad14', action: { type: 'coming' } },
          { key: 'ieo', title: 'IEO全球经济学奥林匹克', subtitle: '国际经济学竞赛', color: '#fa8c16', action: { type: 'coming' } }
        ]
      },
      highSchoolCategories: [
        { key: 'math',
title: '数学（个人）',
items: [
          { key: 'amc10', title: '美国数学测评 AMC 10', action: { type: 'amc', level: 'amc10' } },
          { key: 'amc12', title: '美国数学测评 AMC 12', action: { type: 'amc', level: 'amc12' } },
          { key: 'smc', title: '英国数学测评 SMC', action: { type: 'coming' } }
        ] },
        { key: 'physics',
title: '物理',
items: [
          { key: 'bpho', title: '英国物理测评 BPhO', action: { type: 'coming' } },
          { key: 'physicsbowl', title: '物理杯 PhysicsBowl', action: { type: 'coming' } }
        ] },
        { key: 'cs',
title: '信息学',
items: [
          { key: 'bebras', title: '海狸计算思维挑战', action: { type: 'gesp' } },
          { key: 'acsl', title: 'ACSL 计算机科学测评', action: { type: 'coming' } }
        ] }
      ],
      middleSchoolCategories: [
        { key: 'math',
title: '数学',
items: [
          { key: 'amc8', title: '美国数学测评 AMC 8', action: { type: 'amc', level: 'amc8' } },
          { key: 'kangaroo', title: '袋鼠数学思维挑战', action: { type: 'kangaroo', level: 3 } }
        ] },
        { key: 'cs',
title: '信息学',
items: [
          { key: 'bebras', title: '海狸计算思维挑战', action: { type: 'gesp' } },
          { key: 'gesp', title: 'GESP 编程等级考试', action: { type: 'gesp' } }
        ] }
      ],
      primarySchoolCategories: [
        { key: 'math',
title: '数学',
items: [
          { key: 'kangaroo', title: '袋鼠数学思维挑战', action: { type: 'kangaroo', level: 1 } }
        ] },
        { key: 'cs',
title: '信息学',
items: [
          { key: 'bebras', title: '海狸计算思维挑战', action: { type: 'gesp' } }
        ] }
      ]
    }
  },
  computed: {
    isLoggedIn() {
      this.authTick
      const userInfo = localStorage.getItem('userInfo')
      return !!(userInfo && getToken())
    },
    currentUserInfo() {
      try {
        this.authTick
        const userInfo = localStorage.getItem('userInfo')
        return userInfo ? JSON.parse(userInfo) : null
      } catch (e) {
        console.error('解析用户信息失败:', e)
        return null
      }
    },
    userName() {
      try {
        this.authTick
        const userInfo = localStorage.getItem('userInfo')
        if (userInfo) {
          const user = JSON.parse(userInfo)
          return user.realName || user.username || user.name || '用户'
        }
      } catch (e) {
        console.error('解析用户信息失败:', e)
      }
      return '用户'
    },
    currentUserId() {
      try {
        this.authTick
        const tokenInfo = getTokenInfo && getTokenInfo()
        if (tokenInfo && tokenInfo.id != null) return tokenInfo.id
      } catch (e) {
        console.error('解析 token 用户信息失败:', e)
      }
      return this.currentUserInfo && this.currentUserInfo.id != null ? this.currentUserInfo.id : null
    },
    currentCategoryProjects() {
      return this.categoryProjects[this.activeCategory] || []
    }
  },
  mounted() {
    window.addEventListener('message', this.onWindowMessage)
    window.addEventListener('storage', this.onStorageChange)
    this.loadBanners()
  },
  beforeDestroy() {
    window.removeEventListener('message', this.onWindowMessage)
    window.removeEventListener('storage', this.onStorageChange)
  },
  methods: {
    async loadBanners() {
      try {
        // 并行加载外部广告和内部广告
        const [externalResp, internalResp] = await Promise.allSettled([
          axios.get('/api/banner/active'),
          axios.get('/api/internal-banner/active')
        ])

        // 内部广告 → 轮播图
        if (internalResp.status === 'fulfilled') {
          const data = internalResp.value.data
          if ((data.code === 200 || data.code === 1) && data.data) {
            this.heroSlides = data.data.map(banner => ({
              id: banner.id,
              bannerType: 'internal',
              key: `int-banner-${banner.id}`,
              title: banner.title,
              desc: banner.description,
              image: banner.imageUrl,
              action: this.parseBannerAction(banner)
            }))
          }
        }

        // 外部广告 → 悉迹精选（新闻列表）
        if (externalResp.status === 'fulfilled') {
          const data = externalResp.value.data
          if ((data.code === 200 || data.code === 1) && data.data) {
            this.externalBanners = data.data.map(banner => ({
              id: banner.id,
              bannerType: 'external',
              key: `ext-banner-${banner.id}`,
              title: banner.title,
              desc: banner.description,
              image: banner.imageUrl,
              action: this.parseBannerAction(banner)
            }))
          }
        }
      } catch (error) {
        console.error('加载广告失败:', error)
      }
    },
    parseBannerAction(banner) {
      try {
        const params = banner.linkParams ? JSON.parse(banner.linkParams) : {}
        return {
          type: banner.linkType,
          ...params
        }
      } catch (e) {
        console.error('解析广告链接参数失败:', e)
        return { type: banner.linkType }
      }
    },
    async recordBannerClick(bannerId, bannerType) {
      if (!bannerId) return
      try {
        const apiBase = bannerType === 'internal' ? '/api/internal-banner' : '/api/banner'
        await axios.post(`${apiBase}/${bannerId}/click`)
      } catch (error) {
        console.error('记录广告点击失败:', error)
      }
    },
    bumpAuthTick() {
      this.authTick += 1
    },
    onWindowMessage(event) {
      const data = event && event.data
      if (!data || data.type !== 'LOGIN_SUCCESS') return
      this.bumpAuthTick()
      const redirect = data.redirect
      if (redirect && redirect !== this.$route.fullPath) {
        const ret = this.$router.push(redirect)
        if (ret && typeof ret.catch === 'function') {
          ret.catch(() => {})
        }
      }
    },
    onStorageChange(event) {
      if (!event) return
      if (event.key === 'userInfo' || event.key === 'roles') {
        this.bumpAuthTick()
      }
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    doSearch() {
      const kw = (this.searchKeyword || '').trim()
      if (!kw) return
      this.$message.info('搜索功能开发中')
    },
    onSlideAction(slide) {
      if (!slide || !slide.action) return
      if (slide.id) {
        this.recordBannerClick(slide.id, slide.bannerType)
      }
      this.handleAction(slide.action)
    },
    onRecommendPanelClick(item) {
      if (!item || !item.action) return
      this.handleAction(item.action)
    },
    handleProjectClick(project) {
      if (!project || !project.action) return
      this.handleAction(project.action)
    },
    onExternalBannerClick(item) {
      if (!item) return
      this.recordBannerClick(item.id, 'external')
      if (item.action) {
        this.handleAction(item.action)
      }
    },
    handleAction(action) {
      if (action.type === 'intro') {
        this.goIntro(action.introType)
      } else if (action.type === 'amc') {
        this.goAmc(action.level)
      } else if (action.type === 'kangaroo') {
        this.goKangaroo(action.level)
      } else if (action.type === 'gesp') {
        this.gespComingSoon()
      } else {
        this.$message.info('敬请期待')
      }
    },
    goIntro(type) {
      this.$router.push({ path: `/intro/${type}` })
    },
    goLogin() {
      const href = this.$router.resolve({
        path: '/login',
        query: { redirect: this.$route.fullPath }
      }).href
      window.open(href, '_blank')
    },
    goRegister() {
      this.$router.push('/register')
    },
    goCompetitionArchive() {
      if (!this.isLoggedIn) {
        this.$router.push({ path: '/login', query: { redirect: '/competition-archive' } })
        return
      }
      this.$router.push('/competition-archive')
    },
    goParentArchive() {
      if (!this.isLoggedIn) {
        this.$router.push({ path: '/login', query: { redirect: '/competition-archive' } })
        return
      }
      this.$router.push('/competition-archive')
    },
    goDashboard() {
      if (!this.isLoggedIn) {
        this.$router.push({ path: '/login', query: { redirect: '/dashboard' } })
        return
      }
      if (this.currentUserInfo && this.currentUserInfo.roleId === 1) {
        this.$router.push('/subject-select')
        return
      }
      const redirectPath = this.currentUserInfo ? getUserRedirectPath(this.currentUserInfo) : '/dashboard'
      this.$router.push(redirectPath)
    },
    goContact() {
      this.$router.push('/contact')
    },
    openAppDownloadPage() {
      const href = this.$router.resolve({ path: '/app-download' }).href
      window.open(href, '_blank')
    },
    goAmc(level) {
      // 无需登录，直接进入介绍页
      const introMap = { amc8: 'amc8', amc10: 'amc10', amc12: 'amc12' }
      const introType = introMap[level] || level
      this.$router.push({ path: `/intro/${introType}` })
    },
    goKangaroo(level) {
      // 无需登录，直接进入介绍页
      this.$router.push({ path: '/intro/kangaroo', query: level ? { level: String(level) } : {} })
    },
    normalizeCourseTypeCode(raw) {
      const s = String(raw || '').trim().toUpperCase()
      if (!s) return ''
      if (s.includes('KANGAROO') || s.includes('袋鼠')) return 'KANGAROO'
      if (s.includes('GESP') || s.includes('CCF')) return 'GESP'
      if (s.includes('AMC')) return 'AMC'
      return s
    },
    normalizeSubjectCode(raw, courseTypeCode) {
      const s = String(raw || '').trim()
      if (!s) return ''
      if (this.normalizeCourseTypeCode(courseTypeCode) === 'AMC') {
        const lower = s.toLowerCase()
        if (lower.includes('amc8')) return 'amc8'
        if (lower.includes('amc10')) return 'amc10'
        if (lower.includes('amc12')) return 'amc12'
      }
      return s
    },
    async getRepoListCached() {
      if (Array.isArray(this.repoListCache) && this.repoListCache.length) {
        return this.repoListCache
      }
      try {
        const res = await fetchRepoList()
        const list = Array.isArray(res) ? res : (Array.isArray(res?.data) ? res.data : [])
        this.repoListCache = Array.isArray(list) ? list : []
      } catch (e) {
        console.error('加载 repo 列表失败:', e)
        this.repoListCache = []
      }
      return this.repoListCache
    },
    resolveRepoTitleByRepoId(repoId, repoList) {
      if (repoId == null || repoId === '') return ''
      const rid = Number(repoId)
      const list = Array.isArray(repoList) ? repoList : []
      const matched = list.find(item => Number(item?.id) === rid)
      return String(matched?.title || '').trim()
    },
    inferCourseMetaByRepoTitle(repoTitle) {
      const raw = String(repoTitle || '').trim()
      const upper = raw.toUpperCase()
      if (!raw) {
        return { courseTypeCode: '', subjectCode: '' }
      }
      if (upper.includes('AMC8')) return { courseTypeCode: 'AMC', subjectCode: 'amc8' }
      if (upper.includes('AMC10')) return { courseTypeCode: 'AMC', subjectCode: 'amc10' }
      if (upper.includes('AMC12')) return { courseTypeCode: 'AMC', subjectCode: 'amc12' }
      if (upper.includes('袋鼠')) {
        const levelMatch = upper.match(/LEVEL\s*(\d+)/)
        return { courseTypeCode: 'KANGAROO', subjectCode: levelMatch ? String(levelMatch[1]) : '' }
      }
      if (upper.includes('GESP')) {
        const levelMatch = upper.match(/LEVEL\s*(\d+)/)
        const subjectCode = levelMatch ? String(levelMatch[1]) : (upper.includes('编程题库') ? 'code' : '')
        return { courseTypeCode: 'GESP', subjectCode }
      }
      return { courseTypeCode: '', subjectCode: '' }
    },
    formatSelectedCourseTitle(plan, repoList) {
      const courseTypeCode = this.normalizeCourseTypeCode(plan?.courseType || plan?.courseTypeCode || plan?.courseTypeName)
      const subjectCode = this.normalizeSubjectCode(plan?.subjectCode || plan?.courseName || plan?.planName, courseTypeCode)
      const repoId = plan?.repoId != null && plan?.repoId !== '' ? Number(plan.repoId) || plan.repoId : undefined
      const mappedCourseName = this.resolveRepoTitleByRepoId(repoId, repoList)
      const courseName = mappedCourseName || String(plan?.courseName || plan?.planName || plan?.title || '').trim()
      if (courseTypeCode === 'AMC') {
        if (courseName) return courseName
        const level = subjectCode ? String(subjectCode).toUpperCase() : ''
        return level ? `AMC-${level}` : (courseName || 'AMC课程')
      }
      if (courseTypeCode === 'KANGAROO') {
        return courseName || (subjectCode ? `袋鼠数学-${subjectCode}` : '袋鼠数学')
      }
      if (courseTypeCode === 'GESP') {
        return courseName || (subjectCode ? `GESP-${subjectCode}` : 'GESP')
      }
      return courseName || `${courseTypeCode || '课程'}学习计划`
    },
    mapPlanToSelectedCourse(plan, idx, repoList) {
      const repoId = plan?.repoId != null && plan?.repoId !== '' ? Number(plan.repoId) || plan.repoId : undefined
      const repoTitle = this.resolveRepoTitleByRepoId(repoId, repoList)
      const inferredMeta = this.inferCourseMetaByRepoTitle(repoTitle)
      const rawCourseTypeCode = this.normalizeCourseTypeCode(plan?.courseType || plan?.courseTypeCode || plan?.courseTypeName)
      const courseTypeCode = inferredMeta.courseTypeCode || rawCourseTypeCode
      const subjectCode = inferredMeta.subjectCode || this.normalizeSubjectCode(plan?.subjectCode || plan?.courseName || plan?.planName, courseTypeCode)
      const title = this.formatSelectedCourseTitle(plan, repoList)
      const subtitleParts = [
        plan?.targetYear ? `备考年份 ${plan.targetYear}` : '',
        Number(plan?.isActive) === 1 ? '当前计划' : ''
      ].filter(Boolean)
      return {
        key: String(plan?.id || `${courseTypeCode}_${subjectCode}_${idx}`),
        title,
        subtitle: subtitleParts.join(' · ') || '点击进入备考中心',
        courseTypeCode,
        subjectCode,
        repoId,
        rawPlan: plan
      }
    },
    async openSelectedCourses() {
      if (!this.isLoggedIn || !this.currentUserId) {
        this.$router.push({ path: '/login', query: { redirect: this.$route.fullPath } })
        return
      }
      this.selectedCoursesVisible = true
      this.selectedCoursesLoading = true
      try {
        const res = await getPlansByUserId(this.currentUserId)
        const list = res?.data
        const plans = Array.isArray(list) ? list : []
        const repoList = await this.getRepoListCached()
        const deduped = []
        const seen = new Set()
        plans.forEach((plan, idx) => {
          const item = this.mapPlanToSelectedCourse(plan, idx, repoList)
          const dedupeKey = `${item.courseTypeCode}_${item.subjectCode}_${item.repoId || ''}`
          if (seen.has(dedupeKey)) return
          seen.add(dedupeKey)
          deduped.push(item)
        })
        this.selectedCourses = deduped
      } catch (e) {
        console.error('加载已选课程失败:', e)
        this.selectedCourses = []
        this.$message.error('加载已选课程失败')
      } finally {
        this.selectedCoursesLoading = false
      }
    },
    goToSelectedCourse(item) {
      if (!item) return
      this.selectedCoursesVisible = false
      if (item.courseTypeCode === 'AMC' || item.courseTypeCode === 'KANGAROO') {
        const query = {
          ...(item.subjectCode ? { level: item.subjectCode } : {}),
          ...(item.courseTypeCode ? { courseTypeCode: item.courseTypeCode } : {}),
          ...(item.repoId ? { repoId: item.repoId } : {})
        }
        this.$router.push({ path: '/amc-course', query })
        return
      }
      if (item.courseTypeCode === 'GESP') {
        const query = {
          ...(item.subjectCode && item.subjectCode !== 'code' ? { level: item.subjectCode } : {}),
          courseTypeCode: 'GESP',
          ...(item.repoId ? { repoId: item.repoId } : {})
        }
        this.$router.push({ path: '/amc-course', query })
        return
      }
      this.$router.push('/subject-select')
    },
    goCcfGesp() {
      // 无需登录，直接进入介绍页
      this.$router.push({ path: '/intro/gesp' })
    },
    gespComingSoon(level) {
      // 无需登录，直接进入介绍页
      this.$router.push({ path: '/intro/gesp', query: level ? { level: String(level) } : {} })
    },
    englishComingSoon() {
      this.$message.info('英语课程敬请期待')
    },
    handleUserCommand(command) {
      if (command === 'dashboard') {
        this.$router.push('/amc-profile')
      } else if (command === 'selectedCourses') {
        this.openSelectedCourses()
      } else if (command === 'competitionArchive') {
        this.goCompetitionArchive()
      } else if (command === 'subjectSelect') {
        if (this.currentUserInfo && this.currentUserInfo.roleId === 1) {
          this.$router.push('/subject-select')
          return
        }
        this.goDashboard()
      } else if (command === 'logout') {
        this.logout()
      }
    },
    logout() {
      removeToken()
      localStorage.removeItem('userInfo')
      this.$message.success('已退出登录')
      this.$router.push('/')
      // 强制刷新页面以更新状态
      setTimeout(() => {
        window.location.reload()
      }, 300)
    }
  }
}
</script>

<style scoped>
.landing {
  min-height: 100vh;
  background: #f5f7fa;
}

/* Header Styles */
.header {
  position: sticky;
  top: 0;
  z-index: 100;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.header-top {
  background: #1a1a2e;
  color: #fff;
  font-size: 13px;
}

.header-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-top .header-container {
  height: 36px;
}

.header-links {
  display: flex;
  gap: 24px;
}

.header-link {
  color: rgba(255, 255, 255, 0.85);
  text-decoration: none;
  transition: color 0.2s;
}

.header-link:hover {
  color: #fff;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 20px;
}

.lang-switch {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
}

.lang-active {
  color: #fff;
  font-weight: 600;
}

.lang-divider {
  color: rgba(255, 255, 255, 0.4);
}

.lang-item {
  color: rgba(255, 255, 255, 0.6);
  cursor: pointer;
}

.lang-item:hover {
  color: #fff;
}

.auth-btns {
  display: flex;
  align-items: center;
  gap: 8px;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #fff;
  font-size: 13px;
  cursor: pointer;
  padding: 6px 12px;
  border-radius: 4px;
  transition: background 0.2s;
}

.user-info:hover {
  background: rgba(255, 255, 255, 0.1);
}

.user-info .el-icon-user-solid {
  font-size: 16px;
}

.user-name {
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.selected-courses-dialog {
  min-height: 120px;
}

.selected-courses-empty {
  text-align: center;
  color: #909399;
  padding: 24px 0;
}

.selected-courses-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.selected-course-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  border: 1px solid #ebeef5;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.selected-course-item:hover {
  border-color: #409EFF;
  background: #f5faff;
}

.selected-course-main {
  min-width: 0;
}

.selected-course-title {
  color: #303133;
  font-size: 14px;
  font-weight: 600;
}

.selected-course-subtitle {
  color: #909399;
  font-size: 12px;
  margin-top: 4px;
}

.selected-course-arrow {
  color: #c0c4cc;
  font-size: 14px;
}

.header-main {
  background: #fff;
}

.header-main .header-container {
  height: 72px;
}

.logo-wrap {
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 10px;
}

.logo-img {
  height: 56px;
  width: auto;
  max-width: 220px;
  object-fit: contain;
  display: block;
}

.logo-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.logo-title {
  font-size: 18px;
  font-weight: 700;
  color: #1a1a2e;
  line-height: 1.1;
}

.logo-subtitle {
  font-size: 12px;
  color: #666;
  margin-top: 2px;
}

.main-nav {
  flex: 1;
  display: flex;
  justify-content: center;
}

.nav-items {
  display: flex;
  align-items: center;
  gap: 8px;
}

.nav-item {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 10px 20px;
  font-size: 15px;
  font-weight: 500;
  color: #333;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.2s;
}

.nav-item:hover {
  color: #1890ff;
  background: #f0f5ff;
}

.nav-item i {
  font-size: 12px;
  transition: transform 0.2s;
}

.header-search {
  width: 200px;
}

.search-input {
  border-radius: 20px;
}

/* Hero Section */
.hero-section {
  width: 100%;
}

.hero-carousel {
  width: 100%;
}

.hero-slide {
  width: 100%;
  height: 500px;
  background-size: cover;
  background-position: center;
  position: relative;
  display: flex;
  align-items: center;
}

.hero-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(90deg, rgba(26, 26, 46, 0.85) 0%, rgba(26, 26, 46, 0.4) 50%, transparent 100%);
}

.hero-content {
  position: relative;
  z-index: 1;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  width: 100%;
}

.hero-title {
  font-size: 42px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 16px;
  max-width: 600px;
}

.hero-desc {
  font-size: 18px;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 32px;
  max-width: 500px;
  line-height: 1.6;
}

.hero-btn {
  padding: 12px 32px;
  font-size: 16px;
  border-radius: 4px;
}

/* Section Common */
.section-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

.section-header {
  text-align: center;
  margin-bottom: 48px;
}

.section-title {
  font-size: 32px;
  font-weight: 700;
  color: #1a1a2e;
  margin-bottom: 12px;
}

.section-subtitle {
  font-size: 16px;
  color: #666;
}

.recommend-section {
  padding: 56px 0 24px;
  background: #f5f7fa;
}

.recommend-header {
  text-align: center;
  font-size: 20px;
  font-weight: 700;
  color: #1a1a2e;
  letter-spacing: 2px;
  margin-bottom: 28px;
}

.recommend-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.recommend-card {
  position: relative;
  height: 220px;
  border-radius: 6px;
  overflow: hidden;
  cursor: pointer;
  background-size: cover;
  background-position: center;
  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.10);
  transition: transform 0.22s ease, box-shadow 0.22s ease;
}

.recommend-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 14px 34px rgba(0, 0, 0, 0.14);
}

.recommend-mask {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.12) 0%, rgba(0, 0, 0, 0.45) 100%);
  transition: background 0.22s ease;
}

.recommend-card:hover .recommend-mask {
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.18) 0%, rgba(0, 0, 0, 0.58) 100%);
}

.recommend-title {
  position: absolute;
  left: 16px;
  right: 16px;
  bottom: 18px;
  color: #fff;
  font-size: 20px;
  font-weight: 700;
  text-align: center;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);
  line-height: 1.3;
}

@media (max-width: 992px) {
  .recommend-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 640px) {
  .recommend-grid {
    grid-template-columns: 1fr;
  }
  .recommend-card {
    height: 200px;
  }
}

/* Featured Section - 悉迹精选 */
.featured-section {
  padding: 60px 0;
  background: #fff;
}

.news-feed {
  display: flex;
  flex-direction: column;
  gap: 0;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

.news-item {
  display: flex;
  align-items: center;
  padding: 16px 20px;
  cursor: pointer;
  transition: background 0.2s;
  border-bottom: 1px solid #f0f0f0;
}

.news-item:last-child {
  border-bottom: none;
}

.news-item:hover {
  background: #f8faff;
}

.news-image {
  width: 120px;
  height: 80px;
  flex-shrink: 0;
  border-radius: 8px;
  overflow: hidden;
  margin-right: 20px;
}

.news-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.news-info {
  flex: 1;
  min-width: 0;
}

.news-title {
  font-size: 16px;
  font-weight: 600;
  color: #1a1a2e;
  margin-bottom: 6px;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.news-item:hover .news-title {
  color: #1890ff;
}

.news-desc {
  font-size: 13px;
  color: #999;
  line-height: 1.5;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.news-arrow {
  flex-shrink: 0;
  color: #ccc;
  font-size: 16px;
  margin-left: 16px;
  transition: color 0.2s;
}

.news-item:hover .news-arrow {
  color: #1890ff;
}

/* Projects Section - 热门项目 */
.projects-section {
  padding: 60px 0;
  background: #f5f7fa;
}

.projects-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

.project-card {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  transition: transform 0.3s, box-shadow 0.3s;
}

.project-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.project-card-image {
  height: 180px;
  background-size: cover;
  background-position: center;
  position: relative;
}

.project-card-badge {
  position: absolute;
  top: 12px;
  left: 12px;
  background: #ff4d4f;
  color: #fff;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
}

.project-card-body {
  padding: 20px;
}

.project-card-title {
  font-size: 18px;
  font-weight: 600;
  color: #1a1a2e;
  margin-bottom: 8px;
}

.project-card-desc {
  font-size: 14px;
  color: #666;
  margin-bottom: 16px;
  line-height: 1.5;
}

.project-card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.project-card-tag {
  background: #f0f5ff;
  color: #1890ff;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
}

.project-card-action {
  color: #1890ff;
  font-size: 14px;
  font-weight: 500;
}

/* Categories Section */
.categories-section {
  padding: 80px 0;
  background: #f5f7fa;
}

.category-tabs {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-bottom: 40px;
  flex-wrap: wrap;
}

.category-tab {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  background: #fff;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 15px;
  color: #666;
  border: 2px solid transparent;
}

.category-tab:hover {
  color: #1890ff;
  border-color: #1890ff;
}

.category-tab.active {
  background: #1890ff;
  color: #fff;
  border-color: #1890ff;
}

.category-tab i {
  font-size: 18px;
}

.category-content {
  background: #fff;
  border-radius: 12px;
  padding: 32px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
}

.project-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.project-item {
  display: flex;
  align-items: center;
  padding: 16px 20px;
  background: #fafafa;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
}

.project-item:hover {
  background: #f0f5ff;
}

.project-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 20px;
  margin-right: 16px;
}

.project-info {
  flex: 1;
}

.project-title {
  font-size: 16px;
  font-weight: 600;
  color: #1a1a2e;
  margin-bottom: 4px;
}

.project-subtitle {
  font-size: 13px;
  color: #999;
}

.project-arrow {
  color: #ccc;
  font-size: 16px;
}

.project-item:hover .project-arrow {
  color: #1890ff;
}

/* Stats Section */
.stats-section {
  padding: 80px 0;
  background: linear-gradient(135deg, #1a1a2e 0%, #2d2d44 100%);
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 32px;
}

.stat-item {
  text-align: center;
}

.stat-number {
  font-size: 48px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 8px;
}

.stat-label {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.7);
}

/* Footer */
.footer {
  background: #1a1a2e;
  color: #fff;
}

.footer-main {
  padding: 60px 0;
}

.footer-grid {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  gap: 48px;
}

.footer-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 20px;
  color: #fff;
}

.footer-text {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.8;
}

.footer-links {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.footer-link {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  transition: color 0.2s;
}

.footer-link:hover {
  color: #fff;
}

.footer-app-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.footer-app-tip {
  margin-top: 12px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.65);
  line-height: 1.8;
}

.footer-contact p {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding: 20px 0;
  text-align: center;
}

.footer-bottom p {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.5);
  margin: 0;
  line-height: 1.8;
}

.beian-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.copyright {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.5);
}

.beian-link {
  color: rgba(255, 255, 255, 0.5);
  text-decoration: none;
  transition: color 0.3s;
}

.beian-link:hover {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: underline;
}

/* Responsive */
@media (max-width: 1024px) {
  .news-image {
    width: 100px;
    height: 68px;
  }

  .projects-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .footer-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .header-top {
    display: none;
  }

  .main-nav {
    display: none;
  }

  .hero-title {
    font-size: 28px;
  }

  .hero-desc {
    font-size: 14px;
  }

  .news-image {
    width: 80px;
    height: 56px;
    margin-right: 12px;
  }

  .news-title {
    font-size: 14px;
  }

  .news-desc {
    display: none;
  }

  .projects-grid {
    grid-template-columns: 1fr;
  }

  .project-list {
    grid-template-columns: 1fr;
  }

  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
  }

  .stat-number {
    font-size: 32px;
  }

  .footer-grid {
    grid-template-columns: 1fr;
    gap: 32px;
  }

  .section-title {
    font-size: 24px;
  }
}
</style>

<style>
/* 导航下拉菜单样式 - 白底高对比度 */
.nav-dropdown-popper {
  background: #fff !important;
  border: 1px solid #e8e8e8 !important;
  border-radius: 8px !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12) !important;
  padding: 16px !important;
  min-width: 200px !important;
}

.dropdown-content {
  background: #fff;
}

.dropdown-section {
  padding: 8px 0;
}

.dropdown-title {
  font-size: 14px;
  font-weight: 600;
  color: #1a1a2e;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 2px solid #1890ff;
}

.dropdown-items {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.dropdown-items-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

.dropdown-item {
  display: block;
  padding: 8px 12px;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.2s;
  text-decoration: none;
}

.dropdown-item:hover {
  background: #f0f5ff;
  color: #1890ff;
}

.dropdown-divider {
  height: 1px;
  background: #e8e8e8;
  margin: 12px 0;
}

.hero-carousel .el-carousel__arrow {
  width: 48px;
  height: 48px;
  font-size: 20px;
  background: rgba(255, 255, 255, 0.2);
}

.hero-carousel .el-carousel__arrow:hover {
  background: rgba(255, 255, 255, 0.4);
}

.hero-carousel .el-carousel__indicators {
  bottom: 24px;
}

.hero-carousel .el-carousel__indicator .el-carousel__button {
  width: 32px;
  height: 4px;
  border-radius: 2px;
}
</style>
